import config from '@/Constants';
import { useQuery } from 'react-query';
import { Workflow } from '../types/Workflow';

export function useFlowQuery(id: string) {
  const query = useQuery<Workflow>(`${config.WORKFLOWS_URL}/${id}`);

  return query;
}
